import { getUserAgentData, getUserAgent, UserAgentDataInterface } from './user-agent.helper';

export interface AdditionalRequestParamsInterface {
    userAgentData: UserAgentDataInterface;
    ua?: string;
}

export function prepareRequestParams(params: object, portalUAD: string, baseUA?: string): object {
    const additionalRequestParams: AdditionalRequestParamsInterface = {
        userAgentData: getUserAgentData(portalUAD),
    };
    const userAgent = baseUA && getUserAgent(baseUA);

    if (userAgent) {
        additionalRequestParams.ua = userAgent;
    }

    return {
        ...params,
        ...additionalRequestParams,
    };
}

export function prepareJsonRpcRequestData(method: string, params: object): object {
    return {
        id: 1,
        jsonrpc: '2.0',
        method,
        params,
    };
}
